import type { InferOutput } from "valibot";

export const orderItemSchema = v.object({
  name: v.string(),
  product: v.optional(productDocumentSchema),
  quantity: v.number(),
  meta_data: v.array(v.object({
    label: v.string(),
    value: v.string(),
  })),
  subtotal: v.number(),
});
export type OrderItem = InferOutput<typeof orderItemSchema>;

export const orderTotalsSchema = v.record(v.string(), v.object({
  type: v.string(),
  label: v.string(),
  value: v.string(),
}));
export type OrderTotals = InferOutput<typeof orderTotalsSchema>;

export const orderSchema = v.object({
  order_id: v.number(),
  timestamp: v.number(),
  status: v.string(),
  customer: customerSchema,
  items: v.array(orderItemSchema),
  item_count: v.number(),
  total_order: v.number(),
  total_refunded: v.optional(v.number()),
  totals: orderTotalsSchema,
  links: v.array(linkSchema),
  payment_method: v.string(),
});
export type Order = InferOutput<typeof orderSchema>;

export const myOrdersSchema = v.object({
  orders: v.array(orderSchema),
  orders_total: v.number(),
});
export type MyOrders = InferOutput<typeof myOrdersSchema>;
